<!-- TODO: Add user specific settings for choice of language and date format. -->

<!-- Global Web App Configuration Settings -->
<div class="container">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "SETTINGS.MAIN_CONFIGURATION" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="column">
        <mat-form-field>
          <mat-label>{{ "SETTINGS.ORGANIZATION_NAME" | translate }}</mat-label>
          <input matInput />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "SETTINGS.DESCRIPTION" | translate }}</mat-label>
          <textarea matInput></textarea>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "SETTINGS.SUMMARY" | translate }}</mat-label>
          <textarea matInput></textarea>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "SETTINGS.DEFAULT_LANGUAGE" | translate }}</mat-label>
          <mat-select>
            <mat-option *ngFor="let language of languages" [value]="language">
              {{ language }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "SETTINGS.DEFAULT_DATE_FORMAT" | translate
          }}</mat-label>
          <mat-select>
            <mat-option
              *ngFor="let dateFormat of dateFormats"
              [value]="dateFormat"
            >
              {{ dateFormat }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "SETTINGS.IMAGES" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="column">
        <span class="header">{{ "SETTINGS.FAVICON" | translate }}</span>
        <mifosx-file-upload></mifosx-file-upload>

        <span class="header">{{ "SETTINGS.COVER_IMAGE" | translate }}</span>
        <mifosx-file-upload></mifosx-file-upload>

        <span class="header">{{ "SETTINGS.LOGO" | translate }}</span>
        <mifosx-file-upload></mifosx-file-upload>

        <span class="header">{{
          "SETTINGS.LOGO_WITH_ORGANIZATION_NAME" | translate
        }}</span>
        <mifosx-file-upload></mifosx-file-upload>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "SETTINGS.THEME_AND_FONT" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="column">
        <span class="header">{{ "SETTINGS.THEME" | translate }}</span>
        <mifosx-theme-picker></mifosx-theme-picker>

        <mat-form-field>
          <mat-label>{{ "SETTINGS.DEFAULT_FONT" | translate }}</mat-label>
          <mat-select>
            <mat-option *ngFor="let font of fonts" [value]="font">
              {{ font }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "SETTINGS.CONTACT_INFORMATION" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="column">
        <mat-form-field>
          <mat-label>{{ "SETTINGS.WEBSITE" | translate }}</mat-label>
          <input type="url" matInput />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "USERS.EMAIL" | translate }}</mat-label>
          <input type="email" matInput />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "SETTINGS.CONTACT_NO" | translate }}</mat-label>
          <input type="tel" matInput />
        </mat-form-field>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
